export default __webpack_public_path__ + "static/media/640_business02-en-web.0a53a9ae.png";